<template>
    <div class="extras hireAllocations">
        <h2>{{ $t("Hire items") }}</h2>
        <p>
            <strong>{{
                $t(
                    "Give yourself space on the journey and peace of mind during your holiday by adding a little convenience to your stay at LPO."
                )
            }}</strong>
        </p>
        <p>
            {{
                $t(
                    "Pillow cases, sheets and towels are hired for the duration of your holiday – all other items are priced per week."
                )
            }}
        </p>
        <!-- <pre>{{getLoadedExtrasTranslated}}</pre> -->
        <LoaderAnimation v-if="ajaxLoading"></LoaderAnimation>
        <table
            border="0"
            cellspacing="0"
            cellpadding="4"
            class="table"
            id="hireitemstable"
            v-else
        >
            <thead>
                <tr>
                    <th align="left" scope="col">{{ $t("Description") }}</th>
                    <th align="left" scope="col">{{ $t("Price") }}</th>
                    <th align="left" scope="col">{{ $t("Qty") }}</th>
                    <th align="left" scope="col">
                        <span v-if="getTotalPrice > 0">
                            {{ $t("Total") }}: {{ getCurrency.symbol
                            }}{{ getTotalPrice }}
                        </span>
                    </th>
                </tr>
            </thead>
            <tr
                v-for="(extra, index) in getLoadedExtrasTranslated"
                :key="index"
                :class="{ unavailable_item: isItemUnavailable(extra) }"
            >
                <td>
                    {{ extra.Item }}
                    <span
                        v-if="isItemUnavailable(extra)"
                        class="unavailable-text"
                        >{{ $t("(Unavailable)") }}</span
                    >
                </td>
                <td>
                    {{ getCurrency.symbol }}{{ extra.Price }}/<span
                        v-if="extra.PerWeek == 1"
                        >{{ $t("per week") }}</span
                    ><span v-else>{{ $t("per holiday") }}</span>
                </td>
                <!-- <td>{{extra.Available}}</td> -->
                <!-- <td>{{extra.Id}}</td> -->
                <td>
                    <input
                        @blur="updateState"
                        @keyup="validateItemQuantity(extra.Id, extra.Free)"
                        @change="validateItemQuantity(extra.Id, extra.Free)"
                        :class="{
                            invalid_value: isInvalidQty(extra.Id, extra.Free)
                        }"
                        type="number"
                        min="0"
                        :max="getMaxQuantity(extra.Free)"
                        v-model="extras[extra.Id]"
                        :disabled="isItemUnavailable(extra)"
                    />
                </td>
                <td>
                    {{
                        showTotalPrice(
                            extra.PerWeek,
                            extra.Price,
                            extras[extra.Id]
                        )
                    }}
                </td>
            </tr>
        </table>
    </div>
    <div class="continue_button">
        <button class="button blue" v-if="false">Phone me</button> &nbsp;
        <button
            href="#"
            class="button blue"
            v-if="!extrasReceived"
            @click.prevent="fetchExtras"
        >
            {{ $t("Click here to reload extras") }}
        </button>
        &nbsp;
        <button
            href="#"
            class="button blue"
            :disabled="hasInvalidSelections || !extrasReceived"
            @click.prevent="continueToTravel"
        >
            {{ $t("Continue") }} &gt;&gt;
        </button>
    </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            extras: {},
            ajaxLoading: false,
            extrasReceived: false,
            invalidSelections: {},
            availableItems: []
        };
    },
    methods: {
        continueToTravel() {
            // Validate all selections before proceeding
            if (this.validateAllSelections()) {
                this.$store.commit("CHANGE_PROGRESS_STEP", 2);
                this.$router.push({
                    name: "TravelAndInsurance",
                    hash: "#appTop"
                });
            }
        },
        updateState() {
            // First validate all selections
            this.validateAllSelections();

            this.$store.commit("UPDATE_HIRE_ITEMS", {
                items: this.extras,
                price: this.getTotalPrice
            });
        },
        reloadExtras() {
            console.log("extrasReceived", this.extrasReceived);
            this.fetchExtras();
        },
        validateItemQuantity(itemId, freeAmount) {
            const qty = parseInt(this.extras[itemId]) || 0;
            const maxQty = this.getMaxQuantity(freeAmount);

            // Check if quantity is negative or exceeds available items
            const isInvalid = qty < 0 || (maxQty !== null && qty > maxQty);

            // Store validity state in the invalidSelections object
            this.invalidSelections[itemId] = isInvalid;

            return !isInvalid;
        },
        validateAllSelections() {
            let isValid = true;

            // Check each selected item
            this.getLoadedExtras.forEach(extra => {
                if (
                    this.extras[extra.Id] &&
                    !this.validateItemQuantity(extra.Id, extra.Free)
                ) {
                    isValid = false;
                }
            });

            // Also check that no unavailable items are selected
            this.getLoadedExtras.forEach(extra => {
                if (
                    this.isItemUnavailable(extra) &&
                    this.extras[extra.Id] > 0
                ) {
                    this.extras[extra.Id] = 0; // Reset unavailable items to 0
                    isValid = false;
                }
            });

            return isValid;
        },
        isItemUnavailable(extra) {
            // Consider item unavailable if Free is <= 0 (but not if Free is null)
            return extra.Free !== null && parseInt(extra.Free) <= 0;
        },
        getMaxQuantity(freeAmount) {
            // If Free is null, no maximum; otherwise return the Free value
            return freeAmount === null ? null : parseInt(freeAmount);
        },
        isInvalidQty(itemId, freeAmount) {
            return this.invalidSelections[itemId] || false;
        },
        changeState(value) {
            // Replaced by more comprehensive validation
        },
        showTotalPrice(perweek, price, qty, currency = true) {
            let total = 0;
            if (qty < 0) qty = 0;
            if (perweek == 1) {
                total = this.getBookingDetails.weeks * price * qty;
            } else {
                total = qty * price;
            }
            // console.log(total);
            if (isNaN(total)) {
                return "";
            } else if (currency) {
                return total == 0 ? "" : this.getCurrency.symbol + total;
            } else {
                return total;
            }
        },
        fetchExtras() {
            this.ajaxLoading = true;
            const CancelToken = axios.CancelToken;
            const source = CancelToken.source();

            const postOptions = {
                d1: this.getBookingDetails.BookedArrivalDate,
                d2: this.getBookingDetails.BookedDeptDate,
                pt: this.getCurrency.PriceTypeID,
                bid: this.getBookingDetails.bookingId,
                accid: this.getBookingDetails.AccomTypeID,
                byoid: this.getBookingDetails.ByoTypeID,
                lang: this.$i18n.locale || "en"
            };

            console.log("postOptions", postOptions);

            axios
                .post(
                    process.env.VUE_APP_ROOT_URL + "booking/get-extras",
                    postOptions,
                    {
                        cancelToken: source.token
                    }
                )
                .then(response => {
                    let loadedExtras = response.data.extras;
                    this.$store.commit("UPDATE_EXTRAS", loadedExtras);
                    this.$store.commit("UPDATE_DEPOSIT", response.data.deposit);

                    let newObj = JSON.parse(JSON.stringify(this.getHireItems));
                    newObj.forEach(element => {
                        this.extras = element;
                    });

                    // Create list of available items for validation
                    this.availableItems = loadedExtras
                        .filter(
                            item =>
                                item.Free === null || parseInt(item.Free) > 0
                        )
                        .map(item => item.Id);

                    this.ajaxLoading = false;
                    this.extrasReceived = true;
                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        console.log("Request canceled:", error.message);
                    } else {
                        console.log(error);
                    }
                    this.ajaxLoading = false;
                });

            // Set timeout to cancel the request after 10 seconds
            setTimeout(() => {
                source.cancel("Operation canceled by the user due to timeout.");
            }, 10000);
        },
        validateSelectionAgainstAvailable() {
            // Validate that no unavailable items are selected
            if (!this.getLoadedExtras) return true;

            for (const extra of this.getLoadedExtras) {
                if (
                    this.isItemUnavailable(extra) &&
                    this.extras[extra.Id] > 0
                ) {
                    return false;
                }
            }
            return true;
        }
    },
    computed: {
        ...mapGetters([
            "getCurrency",
            "getLoadedExtras",
            "getHireItems",
            "getBookingDetails"
        ]),
        hasInvalidFields() {
            return this.getBookingDetails.deposit == null;
        },
        hasInvalidSelections() {
            // Check if there are any invalid selections
            return (
                this.hasInvalidFields ||
                Object.values(this.invalidSelections).some(
                    invalid => invalid
                ) ||
                !this.validateSelectionAgainstAvailable()
            );
        },
        getLoadedExtrasTranslated() {
            // let tmpObj=this.getLoadedExtras;newObj
            let newObj = JSON.parse(JSON.stringify(this.getLoadedExtras));
            if (newObj != null) {
                for (let ii in this.getLoadedExtras) {
                    // console.log('newObj.Item',newObj[ii].Item);
                    if (this.$i18n.locale == "nl") {
                        newObj[ii].Item = newObj[ii].Itemnl;
                    } else if (this.$i18n.locale == "de") {
                        newObj[ii].Item = newObj[ii].Itemde;
                    } else if (this.$i18n.locale == "fr") {
                        newObj[ii].Item = newObj[ii].Itemfr;
                    } else if (this.$i18n.locale == "en") {
                        newObj[ii].Item = newObj[ii].Itemen;
                    }
                }
            }

            return newObj;
        },
        getTotalPrice() {
            this.validateAllSelections();

            const allLoadedExtras = this.getLoadedExtras;
            const arrayOfSelectedIds = Object.keys(this.extras);
            let totalPrice = 0;

            for (const property in allLoadedExtras) {
                let hireItemId = `${allLoadedExtras[property].Id}`;
                // Only calculate price for valid selections
                if (
                    arrayOfSelectedIds.includes(hireItemId) &&
                    !this.isItemUnavailable(allLoadedExtras[property])
                ) {
                    let perweek = `${allLoadedExtras[property].PerWeek}`;
                    let price = `${allLoadedExtras[property].Price}`;
                    let qty = this.extras[hireItemId];
                    totalPrice += this.showTotalPrice(
                        perweek,
                        price,
                        qty,
                        false
                    );
                }
            }
            return totalPrice;
        }
    },
    created() {
        this.fetchExtras();
    },
    unmounted() {
        this.updateState();
    }
};
</script>
<style scoped>
input {
    padding: 6px 10px;
    margin: 2px;
    width: 60px;
}
.invalid_value {
    color: red;
}
.unavailable_item {
    opacity: 0.7;
    background-color: #f9f9f9;
}
.unavailable-text {
    color: rgba(255, 0, 0, 0.6);
    font-size: 0.9em;
    margin-left: 5px;
    font-style: italic;
}
</style>
